class tooltipController {

	isEnabled() {
		return this.enabled;
	}

}

export default tooltipController;
